export const ROLE = {
  ADMIN: "ROLE_ADMIN",
  USER: "ROLE_USER",
  CORP: "ROLE_CORP",
  MANAGER: "ROLE_MANAGER",
};
